import { HttpHeaders } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { LoginResponse } from 'emma-common-ts/skudo';
import { tap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { getCurrentLanguage } from './locale.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  login$ = new EventEmitter<string>();
  logout$ = new EventEmitter<void>();
  headers: HttpHeaders;

  constructor(private apiService: ApiService) {
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Accept-Language': getCurrentLanguage(),
    });
  }

  login = (username: string, password: string) => {
    return this.apiService
      .post<LoginResponse>(
        '/oauth2/login',
        { username, password },
        {
          headers: this.headers,
        }
      )
      .pipe(tap(() => this.login$.next(username)));
  };

  logoutReport() {
    return this.apiService.get<LoginResponse>('/oauth2/logout', {
      headers: this.headers,
    });
  }

  logout() {
    this.logout$.next();
  }

  autoLogin = (token: string) =>
    this.apiService.post<LoginResponse>(
      '/oauth2/authToken',
      { token, code: token },
      {
        headers: this.headers,
      }
    );

  tokenLogin = (token: string) => {
    return this.apiService
      .post<LoginResponse>(
        '/oauth2/loginToken',
        { token },
        {
          headers: this.headers,
        }
      )
      .pipe(tap(() => this.login$.next(token)));
  };
}
